// extracted by mini-css-extract-plugin
module.exports = {"embla":"FreemodeSlide_embla__WGVt0","embla__container":"FreemodeSlide_embla__container__W_oPB","embla__slide":"FreemodeSlide_embla__slide__XwUD0"};